module.exports = __webpack_public_path__ + "img/K_mask.ba47bd05.png";